export enum MemberRole {
  ADMIN = "admin",
  USER = "member",
  OWNER = "owner",
  GUEST = "viewer",
}

